import axios from 'axios';
import qs from 'qs';

const endPoint = 'https://api.kollecta.io';
// const endPoint = 'http://localhost:3003'; 
const baseURL = `${endPoint}/api`;
const timeout = 2147483647;
const axiosInstance = axios.create({ baseURL, timeout })

axiosInstance.interceptors.request.use((config) => ({
  ...config,
  headers: {
    ...config.headers,
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
  paramsSerializer: qs.stringify,
}))

const clearSessionAndGoLogin = (statusCode) => {
  sessionStorage.removeItem('managerPastDues_credores')
  sessionStorage.removeItem('managerPastDues_results')
  sessionStorage.removeItem('managerPastDues_filters')
  sessionStorage.removeItem('managerPastDues_totals')
  window.onerror(`authorization: ${statusCode}`, window.location.href)
  window.location.href = '/#/login'
}

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const res = error.response
    const statusCode = res?.status ?? null
    const data = res?.data

    if (statusCode === 401) {
      clearSessionAndGoLogin(statusCode)
      return Promise.reject(res)
    }

    if (statusCode === 403 && data?.success === false) {
      clearSessionAndGoLogin(statusCode)
    }

    return Promise.reject(res)
  })



export default axiosInstance
